// Blog CTA split test (stepcase/timeblock#1240). The blog tags assessment links
// with `utm_term=ab-nl` (newsletter first) or `utm_term=ab-as` (assessment
// first); `lh_ab` is the property name the blog already registers.
export type AbArm = 'nl' | 'as'

export const AB_ARM_PROPERTY = 'lh_ab'

const AB_TERM_PREFIX = 'ab-'
const AB_ARMS: readonly string[] = ['nl', 'as']

/**
 * Read the split-test arm out of a `utm_term`. Any other term — and there are
 * plenty of non-test terms already in use — yields null.
 */
export function parseAbArm(utmTerm: string | null | undefined): AbArm | null {
  if (!utmTerm || !utmTerm.startsWith(AB_TERM_PREFIX)) return null

  const arm = utmTerm.slice(AB_TERM_PREFIX.length)
  return AB_ARMS.includes(arm) ? (arm as AbArm) : null
}
